import { Button } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { HEADING_FONT } from "@/css/constants";

export const Heading = styled("h1")`
  font-size: 48px;
  color: #a0c6ff;
  font-family: ${HEADING_FONT};
  margin: 0px;
`;

export const Subheading = styled("h2")`
  font-size: 24px;
  font-family: ${HEADING_FONT};
  margin: 0px;
`;

export const BigButton = styled(Button)`
  height: 60px;
  font-size: 18px;
`;
